import { render, staticRenderFns } from "./AddNeighborhoodPage.vue?vue&type=template&id=6fb63080&"
import script from "./AddNeighborhoodPage.vue?vue&type=script&lang=js&"
export * from "./AddNeighborhoodPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports